import { Box, Button } from "@enaep-ng/benchmark";
import * as styleSheet from "../styles";
import { ScreenDialogueProps } from "../types";
import { useEffect, useRef } from "react";

export default function ScreenDialogue(props: ScreenDialogueProps) {
  const popupRef = useRef<HTMLDivElement>(null);
  
  const onCancel = () => {
    props.onCancelAction();
  };

  const onSubmit = () => {
    props.onSubmitAction();
  };

  // This hook is used to close the dialogue when clicked outside the dialogue.
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onCancel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);
  
  return (
    <>
      <Box sx={styleSheet.screenDialogContainer}>
        <Box ref={popupRef} sx={styleSheet.screenDialogBoxWrapper}>
          <Box sx={styleSheet.screenDialogTitleArea}>
            <Box sx={styleSheet.screenDialogTitleText}>{props.title}</Box>
          </Box>
          <Box sx={styleSheet.screenDialogBodyArea}>{props.subTitle}</Box>
          <Box sx={styleSheet.screenDialogButtonWrapper}>
            <Button
              variant="bare"
              onClick={onSubmit}
              style={styleSheet.screenDialogConfirm}
            >
              {props.confirmText}
            </Button>
            <Button
              variant="bare"
              onClick={onCancel}
              style={styleSheet.screenDialogCancel}
            >
              {props.cancelText}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
